import { Http } from '../../../support';
import Storage from '../../../support/Storage';

class SucursalCatalogoManager {
  static __values = null;

  static async boot() {
    let value = await Storage.get('catalogo.sucursal');

    const params = {
      catalogo: 'sucursales',
      version: !!value ? value.version : '1.0',
    };

    let response = {};

    try {
      response = await Http.get('/api/catalogos/sucursal', { params });

      if (!!response.data && response.data.length > 0) {
        value = {
          version: '1.0',
          data: response.data,
        };

        await Storage.put('catalogo.sucursal', value);
      }

      if (!!value) {
        SucursalCatalogoManager.__values = [...value.data];
      }
    } catch (error) {
      throw new Error('Los catálogos de sucursal no están disponibles');
    }
  }

  static get(catalog, _default = []) {
    return SucursalCatalogoManager.__values || _default;
  }

  static all() {
    return SucursalCatalogoManager.__values;
  }
}

export default SucursalCatalogoManager;
